import en from './messages/en.json'

export const resources = {
  en: { translation: en },
}
